export enum ASAP {
  A_EDITER = '01',
  CHORUS_PRO = '02',
  COMPTABLE = '03',
  NON_DEMATERIALISEE = '04',
}

export const ASAP_OPTIONS = [
  {
    value: ASAP.A_EDITER,
    text: `${ASAP.A_EDITER}-ASAP à éditer`,
    key: ASAP.A_EDITER,
    'data-testid': `asapOption${ASAP.A_EDITER}`,
  },
  {
    value: ASAP.CHORUS_PRO,
    text: `${ASAP.CHORUS_PRO}-ASAP à déposer sur Chorus Pro`,
    key: ASAP.CHORUS_PRO,
    'data-testid': `asapOption${ASAP.CHORUS_PRO}`,
  },
  {
    value: ASAP.COMPTABLE,
    text: `${ASAP.COMPTABLE}-ASAP consultable par le comptable uniquement`,
    key: ASAP.COMPTABLE,
    'data-testid': `asapOption${ASAP.COMPTABLE}`,
  },
  {
    value: ASAP.NON_DEMATERIALISEE,
    text: "ASAP Non dématérialisé par l'ordonnateur",
    key: ASAP.NON_DEMATERIALISEE,
    'data-testid': `asapOption${ASAP.NON_DEMATERIALISEE}`,
  },
] as const;
